import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AuthPingService } from 'src/app/core/auth/auth-ping.service';

@Component({
  selector: 'app-end-session-notification',
  templateUrl: './end-session-notification.component.html',
  styleUrls: ['./end-session-notification.component.css']
})
export class EndSessionNotificationComponent implements OnInit {
  showNotification: boolean = false;
  countdown: number = 0;

  constructor(
    public authPingService: AuthPingService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.authPingService.notification$.subscribe((notification) => {
      this.showNotification = notification.show;
      this.countdown = notification.countdown
      this.cdr.detectChanges();
    });
  }

}
